// Brand + platform-wide constants for the unified Gposingway SPA.
//
// Versioned constants (PLATFORM_VERSION, FFXIV_PATCH, etc.) live here as the single source of
// truth for any UI that displays the current platform release. Live values (Studio version +
// download count, Discord member count, catalog totals) come from /api/stats - NOT from this
// file.

export type AppId = 'emporium' | 'auth' | 'www';

export interface Brand {
    letter: string;
    name: string;
    tagline: string;
}

export const BRAND: Record<AppId, Brand> = {
    emporium: {
        letter: 'E',
        name: 'Gposingway Emporium',
        tagline: 'catalog of ReShade presets & resources',
    },
    auth: {
        letter: 'A',
        name: 'Gposingway Auth',
        tagline: 'platform sign-in',
    },
    www: {
        letter: 'G',
        name: 'Gposingway',
        tagline: 'A darkroom for Eorzean light',
    },
};

// ─── versioned constants ───────────────────────────────────────────────────
// Bumped manually per release; surfaces in nav subs, footers, version chips.

export const PLATFORM_VERSION = '8.3'; // Gposingway platform issue / Pack release
export const FFXIV_PATCH = '7.3'; // FFXIV patch level the current Pack targets

// ─── external links ────────────────────────────────────────────────────────
// Central registry for every external link the SPA renders. Keep one source of truth so
// updates and audits stay scoped to a single file.

export const LINKS = {
    github: {
        pack: 'https://github.com/gposingway/gposingway',
        studio: 'https://github.com/gposingway/studio',
        releasesLatest: 'https://github.com/gposingway/gposingway/releases/latest',
        // Step-by-step manual install guide for the Pack (no Studio required).
        installGuide: 'https://github.com/gposingway/gposingway/blob/main/md/installation_guide.md',
    },
    discord: {
        invite: 'https://discord.gg/gposingway',
    },
    reshade: {
        home: 'https://reshade.me',
        mirror: 'https://www.mediafire.com/folder/reshade_versions',
    },
} as const;
